import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import PublishingHeatMap from "../index";
import { axiosInstance } from "services";
import VuiBox from "components/ui/VuiBox";
import StandardLoadingIndicator from "components/StandardLoadingIndicator";
import StandardMessageDisplay from "components/StandardMessageDisplay";

// Design tokens
import { HEATMAP_COLORS } from "utils/designTokens";

function PublishingPatternContainer({ companyId }) {

  const [publishingPatternData, setPublishingPatternData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const colorScheme = HEATMAP_COLORS.default;

  useEffect(() => {
    const fetchPublishingPatterns = async () => {
      if (!companyId) {
        return;
      }

      setError(null);
      try {
        const params = { companyId };
        const response = await axiosInstance.get(
          `/v1/frontend/publishing/patterns`, { params },
        );

        const newData = response.data;
        setPublishingPatternData(currentData =>
          JSON.stringify(currentData) !== JSON.stringify(newData) ? newData : currentData,
        );
        setLoading(false);
      } catch (err) {
        console.error("Error fetching publishing patterns:", err);
        setError("Failed to load publishing patterns data. Please try again later.");
        setPublishingPatternData(null);
        setLoading(false);
      }
    };
    fetchPublishingPatterns();
  }, [companyId]);

  const centeredWrapperSx = {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 0,
    height: "100%",
  };

  if (loading) {
    return (
      <VuiBox sx={centeredWrapperSx}>
        <StandardLoadingIndicator containerHeight="100%" />
      </VuiBox>
    );
  }

  if (error) {
    return (
      <VuiBox sx={centeredWrapperSx}>
        <StandardMessageDisplay
          type="error"
          containerHeight="100%"
        />
      </VuiBox>
    );
  }

  if (publishingPatternData && Object.keys(publishingPatternData).length > 0) {
    return (
      <VuiBox sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
        <PublishingHeatMap data={publishingPatternData} colorScheme={colorScheme} />
      </VuiBox>
    );
  }

  return (
    <VuiBox sx={centeredWrapperSx}>
      <StandardMessageDisplay
        type="noData"
        title="No Publishing Patterns"
        message="No distinct publishing patterns were identified in the market during the chosen timeframe."
        containerHeight="100%"
      />
    </VuiBox>
  );
}

PublishingPatternContainer.propTypes = {
  companyId: PropTypes.string.isRequired,
};

export default PublishingPatternContainer;